var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.campaign.status == 'FINISHED',"loading":_vm.loader},on:{"click":_vm.submit}},[_vm._v(" Sincronizar campanha com DV360 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }